export default __webpack_public_path__ + "css/plugins.bundle.css";